import React, { useState, useEffect, memo } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import { getUserTypeOptions, stateOption } from "../../../utils";
import { decrypt } from "../../../utils/encodingdecoding";
import { getAllCustomer } from "../../../services/services";

const Paginated = memo(({ data, tableColumns, loader, setLoader, selectedUserType, setSelectedUserType, setData, setResponse, customerCount, selectedState, setSelectedState, searchValue, setSearchValue, setCustomerCount }) => {
    const [selectPage, setSelectPage] = useState();
    const [selectedPageIndex, setSelectedPageIndex] = useState(1);
    const [pageArray, setPageArray] = useState();
    const [isSearched, setIsSearched] = useState(false);

    const { getTableProps, getTableBodyProps, rows, headerGroups, page, nextPage, state, prepareRow, setGlobalFilter } = useTable(
        {
            columns: tableColumns,
            data,
            initialState: { pageSize: 50 },
        },
        useGlobalFilter,
        usePagination
    );
    const { globalFilter, pageSize } = state;
    const [inputField, setInputField] = useState(globalFilter); //eslint-disable-line
    const [visibleRowCount, setVisibleRowCount] = useState(pageSize);
    const options = [
        ...getUserTypeOptions(decrypt(localStorage.getItem("Id")))
    ];

    useEffect(() => {
        setGlobalFilter(inputField);
    }, [inputField]); //eslint-disable-line

    useEffect(() => {
        if (customerCount) {
            let tempCustomerCount = customerCount / pageSize;
            let temp = Math.ceil(tempCustomerCount);
            setSelectPage(temp);
        } else {
            setSelectPage(0);
        }
    }, [customerCount]);

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
        if (tempPageIndex !== 1) {
            fetch();
        }
    }, []); //eslint-disable-line

    useEffect(() => {
        const temp = Array.from({ length: selectPage }, (_, index) => index + 1);
        setPageArray(temp);
    }, [selectPage]);

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
        tempPageIndex ? setSelectedPageIndex(tempPageIndex) : setSelectedPageIndex(1);
    }, []);

    const fetch = async () => {
        setLoader(true);
        let tempPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const res = await getAllCustomer(token?.access_token, "customer", true, "Customers", "state", selectedState, "customerType", selectedUserType, tempPageIndex, pageSize)
        if (res.message === "Success") {
            setCustomerCount(res?.totalCount)
            setResponse(res?.data)
        }
        setLoader(false);
    };

    const handlePageIndex = async (event) => {
        if (event.target.value !== "") {
            const number = Number(event.target.value);
            setSelectedPageIndex(number);
            localStorage.setItem("CusPageIndex", JSON.stringify(number));
            fetch();
        }
    };

    const handleNext = () => {
        if (selectedPageIndex < pageArray?.length) {
            setSelectedPageIndex(selectedPageIndex + 1);
            localStorage.setItem("CusPageIndex", JSON.stringify(selectedPageIndex + 1));
            fetch();
            nextPage();
        }
    };
    const handlePrevious = () => {
        if (selectedPageIndex > 1) {
            setSelectedPageIndex(selectedPageIndex - 1);
            localStorage.setItem("CusPageIndex", JSON.stringify(selectedPageIndex - 1));
            fetch();
        }
    };

    const resetFilters = () => {
        setSearchValue("");
        setInputField("");
        setGlobalFilter("");
        setIsSearched(false);
        setData([]);
    };

    const handleFilter = (value) => {
        setSelectedUserType(value);
        resetFilters();
    };

    const handleStateFilter = (value) => {
        setSelectedState(value);
        resetFilters();
    };

    const handleSubmit = async () => {
        setLoader(true);
        setIsSearched(false)
        const token = JSON.parse(localStorage.getItem("token_gen"));

        const res = await getAllCustomer(
            token?.access_token,
            "customer",
            true,
            "Customers",
            "customerType",
            selectedUserType,
            searchValue ? "mobile" : "state",
            searchValue ? searchValue : selectedState,
            1,
            pageSize
        );

        if (res.message === "Success") {
            setCustomerCount(res?.totalCount)
            setResponse(res?.data);
            setIsSearched(true);
        }
        setLoader(false);
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="customTable">
                <div className="customTable__header">
                    <div className="customTable__left">
                        <div className="customTable__showingRecords">
                        </div>
                    </div>
                    <div className="customTable__right">
                        <div className="d-flex gap-2 align-items-center">
                            <ValidatorForm onSubmit={handleSubmit}>
                                <div className="d-flex gap-2">
                                    <div style={{ minWidth: "220px" }}>
                                        <SelectValidator
                                            placeholder="Select"
                                            className="custom-ReactSelect bordered"
                                            name="type"
                                            value={options.find((item) => item.value === selectedUserType) || null}
                                            selected={selectedUserType}
                                            options={options}
                                            onChange={(option) => handleFilter(option.value)}
                                        />
                                    </div>
                                    <>
                                        <div className="customTable__searchFilter">
                                            <label>Mobile:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={searchValue || ""}
                                                maxLength={10}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    if (/^\d*$/.test(value)) {
                                                        setSearchValue(value);

                                                        if (value) {
                                                            setSelectedState(null);
                                                            setData([]);
                                                            setIsSearched(false);
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </>
                                    <div className="customTable__searchFilter"><label>OR</label></div>

                                    <div style={{ minWidth: "220px" }} >
                                        <SelectValidator
                                            placeholder="Select State"
                                            className="custom-ReactSelect bordered"
                                            name="type"
                                            value={stateOption.find((item) => item.value === selectedState) || null}
                                            selected={selectedState}
                                            options={stateOption}
                                            onChange={(option) => handleStateFilter(option.value)}
                                            isDisabled={!!searchValue}
                                        />

                                    </div>
                                    <button type="submit" className="btn btn-primary" disabled={(searchValue?.length !== 10 && !selectedState) || (!selectedState && !selectedUserType)}>
                                        Search
                                    </button>
                                </div>
                            </ValidatorForm>
                        </div>
                    </div>
                </div>
                <div className="customTable__body">
                    <div className="table-responsive">
                        {data?.length ? (
                            <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                                <thead>
                                    {headerGroups.map((headerGroup) => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>

                                <tbody {...getTableBodyProps()}>
                                    {rows.slice(0, visibleRowCount).map((row, rowIndex) => {
                                        prepareRow(row);
                                        return (
                                            <tr {...row.getRowProps()} key={rowIndex}>
                                                {row.cells.map((cell) => {
                                                    return <td {...cell.getCellProps()}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : (
                            isSearched &&
                            <table className="table table-striped table-bordered" {...getTableProps()}>
                                <thead>
                                    {headerGroups.map((headerGroup) => (
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                            ))}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={headerGroups?.[0]?.headers?.length}>
                                            <p style={{ textAlign: "center", margin: 0 }}>No data found</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                {isSearched && <div className="customTable__footer">
                    <div className="customTable__left">
                        <div className="customTable__totalTransactions">
                            <p>
                                Total Customers: <span>{rows.length}</span>
                            </p>
                        </div>
                    </div>
                    <div className="customTable__right">
                        <div className="customTable__top">
                            <div className="customTable__totalPages">
                                {pageArray && (
                                    <p>
                                        Page
                                        <select className="form-control selectArrow" value={selectedPageIndex} onChange={handlePageIndex}>
                                            {pageArray?.length ? (
                                                pageArray.map((value) => (
                                                    <option key={value} value={value}>
                                                        {value}
                                                    </option>
                                                ))
                                            ) : (
                                                <option key={1} value={1}>
                                                    {1}
                                                </option>
                                            )}
                                        </select>
                                        of{pageArray?.length ? (
                                            <span>{pageArray?.length}</span>) : <span>{1}</span>}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="customTable__bottom customTable__bottom__2">
                            <div className="customTable__buttons">
                                <span className="btn btn-outline-primary" onClick={() => handlePrevious()} disabled={selectedPageIndex > 1 ? false : true}>
                                    {"Previous"}
                                </span>
                                <span className="btn btn-outline-primary" onClick={handleNext} disabled={pageArray?.length > 0 ? (selectedPageIndex === pageArray?.length ? true : false) : true}>
                                    {"Next"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </>
    );
});

export default Paginated
